<template>
  <v-card class="mb-4">
    <v-card-title class="text-h6 mb-2 mt-2">
      <h4 class="mb-0">
        <strong> Bultos Actuales </strong>
      </h4>
    </v-card-title>
    <v-card-text class="pa-0">
      <div class="d-flex flex-column ga-3 pa-3">
        <div v-for="pkg in packages" :key="pkg.id" :class="[
          'pa-3 rounded-lg border',
          currentPackageId === pkg.id ? 'border-gray-500 ' : 'border-gray-200'
        ]">
          <div class="d-flex align-center justify-space-between mb-1">
            <span class="font-weight-medium">Bulto {{ pkg.id }}</span>
            <v-chip :variant="currentPackageId === pkg.id ? 'flat' : 'outlined'"
              :color="currentPackageId === pkg.id ? 'primary' : 'default'" size="small">
              {{pkg.items.reduce((acc, item) => acc + item.amount, 0)}} items
            </v-chip>
          </div>

          <div v-if="currentPackageId === pkg.id" class="text-caption text-blue-600">
            ← Empaquetando aquí
          </div>

          <div v-if="pkg.items.length > 0 && currentPackageId === pkg.id" class="mt-2">
            <div class="text-caption text-grey-600 mb-1">Items:</div>
            <PackageItemList 
              :items="pkg.items"
              :package-id="pkg.id"
              :show-remove-button="true"
              @remove-item="removeItemFromPackage"
            />
          </div>
        </div>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>

import AliasMixin from "@/mixins/AliasMixin.vue";
import PackageItemList from "./PackageItemList.vue";

export default {
  name: 'CurrentPackages',
  mixins: [AliasMixin],
  components: {
    PackageItemList
  },
  emits: ['remove-item-from-package'],

  props: {
    packages: {
      type: Array,
      required: true,
      default: () => []
    },
    currentPackageId: {
      type: Number,
      default: 1
    }
  },
  methods: {
    removeItemFromPackage(packageId, item) {
      this.$emit('remove-item-from-package', packageId, item);
    }
  }
};
</script>

<style scoped>
.border-blue-300 {
  border-color: #93c5fd !important;
}

.bg-blue-50 {
  background-color: #eff6ff !important;
}

.border-gray-200 {
  border-color: #e5e7eb !important;
}

.text-blue-600 {
  color: #2563eb !important;
}

.ga-1 {
  gap: 4px;
}

.ga-2 {
  gap: 8px;
}

.ga-3 {
  gap: 12px;
}
</style>
